import * as React from 'react';
import { DirectUpload } from '../media/DirectUpload';
import { FileProps } from '../../types';
import { MediaPreviewComponent } from '../media/MediaPreview';

type HandleMediaUpdateProps = { (mediaType: 'image' | 'video' | 'attachment' | 'audio', url: string) : void; }

type WorkoutGroupMediaComponentProps = {
  handleMediaUpdate: HandleMediaUpdateProps;
  imageUrl?: string;
  videoUrl?: string;
  audioUrl?: string;
  image?: FileProps;
  attachmentUrl?: string;
  video?: FileProps;
  audio?: FileProps;
  attachment?: FileProps;
}

export const WorkoutGroupMediaComponent = ({handleMediaUpdate, ...props} : WorkoutGroupMediaComponentProps) : JSX.Element => {
  return(
    <div className="row">
      <div className="col s12 m6">
        <div className="flow-text">Vídeo</div>
        <DirectUpload 
          mediaType='video' 
          folder="workouts/videos"
          onUploadComplete={(url) => handleMediaUpdate('videoUrl', url)}
        >
          <MediaPreviewComponent
            mediaType='video'
            file={props.video}
            removeAll={() => handleMediaUpdate('videoUrl', '')}
            isUploading={false}
            uploadProgress={0}
          />
        </DirectUpload>
      </div>
      <div className="col s12 m6">
        <div className="flow-text">Audio</div>
        <DirectUpload 
          mediaType='audio' 
          folder="workouts/audios"
          onUploadComplete={(url) => handleMediaUpdate('audioUrl', url)}
        >
          <MediaPreviewComponent
            mediaType='audio'
            file={props.audio}
            removeAll={() => handleMediaUpdate('audioUrl', '')}
            isUploading={false}
            uploadProgress={0}
          />
        </DirectUpload>
      </div>
      <div className="col s12 m6">
        <div className="flow-text">Imagem</div>
        <DirectUpload 
          mediaType='image' 
          folder="workouts/images"
          onUploadComplete={(url) => handleMediaUpdate('coverUrl', url)}
        >
          <MediaPreviewComponent
            mediaType='image'
            file={props.image}
            removeAll={() => handleMediaUpdate('coverUrl', '')}
            isUploading={false}
            uploadProgress={0}
          />
        </DirectUpload>
      </div>
      <div className="col s12 m6">
        <div className="flow-text">Anexo</div>
        <DirectUpload 
          mediaType='attachment' 
          folder="workouts/attachments"
          onUploadComplete={(url) => handleMediaUpdate('attachmentUrl', url)}
        >
          <MediaPreviewComponent
            mediaType='attachment'
            file={props.attachment}
            removeAll={() => handleMediaUpdate('attachmentUrl', '')}
            isUploading={false}
            uploadProgress={0}
          />
        </DirectUpload>
      </div>
    </div>
  )
}